{
  "version": 1,
  "asset_id": "59f0088d-d520-4d26-ac9a-6e2cd1ef9123",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/59f0088d-d520-4d26-ac9a-6e2cd1ef9123/aleph-animal-1400.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/59f0088d-d520-4d26-ac9a-6e2cd1ef9123/aleph-animal-1400.webp",
  "original_filename": "aleph-animal-1400.webp",
  "size": 155242,
  "content_type": "image/webp",
  "created_at": "2026-10-20T23:04:50Z"
}
